import { ITimestamps, IWithActors } from '../firebase/interfaces';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export type PrimaryKey<_Model> = string;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export type ForeignKey<_Model> = { id: string };

export type WithPrimaryKey<Model> = Model & {
  id: PrimaryKey<Model>;
} & ITimestamps &
  IWithActors;
